import { useState, useRef, useEffect } from 'react';

export default function RandomText({ txt, className = "", hover = false, fontSize = "18px" }) {
  const [textState, setTextState] = useState(txt);
  const iterationsRef = useRef(0);
  const intervalRef = useRef(null);

  const animate = () => {
    if (intervalRef.current) return;

    const amt = txt.length * 0.04;
    iterationsRef.current = 0;

    intervalRef.current = setInterval(() => {
      const scrambled = txt
        .split("")
        .map((char, i) => {
          if (i < iterationsRef.current) return txt[i];
          return String.fromCharCode(Math.floor(Math.random() * 26) + 65);
        })
        .join("");

      setTextState(scrambled);
      iterationsRef.current += amt;

      if (iterationsRef.current > txt.length) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
        setTextState(txt);
      }
    }, 60);
  };

    useEffect(() => {
    if (hover) return;

    const loop = setInterval(() => {
        animate();
    }, 4000); // ← gap between each scramble cycle

    animate(); // run immediately on mount too

    return () => {
        clearInterval(loop);
        clearInterval(intervalRef.current);
        intervalRef.current = null;
    };
    }, [txt]);

  return (
    <p className={className} onMouseOver={hover ? animate : undefined} style={{ fontSize }}>
      {textState}
    </p>
  );
}